import { render, staticRenderFns } from "./CurrencyManagements.vue?vue&type=template&id=3ed307ba"
import script from "./CurrencyManagements.vue?vue&type=script&lang=js"
export * from "./CurrencyManagements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports